import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Animated voice waveform. `active` drives the speaking animation.
// SIMULATED for the prototype — a real-time voice AI (e.g. OpenAI Realtime)
// would feed live amplitude data into `levels` later.
export function VoiceWaveform({ active = false, bars = 28, color = "#00E5FF", className, height = 44 }) {
  return (
    <div className={cn("flex items-end justify-center gap-[3px]", className)} style={{ height }} aria-hidden data-testid="voice-waveform">
      {Array.from({ length: bars }).map((_, i) => {
        const base = 0.18 + Math.abs(Math.sin(i * 0.9)) * 0.5;
        return (
          <motion.span
            key={i}
            className="w-[3px] rounded-full"
            style={{ background: color, boxShadow: `0 0 6px ${color}` }}
            animate={
              active
                ? { scaleY: [base, base + 0.6, base * 0.7, base + 0.9, base], opacity: [0.5, 1, 0.6, 1, 0.5] }
                : { scaleY: 0.14, opacity: 0.35 }
            }
            transition={active ? { duration: 0.9 + (i % 5) * 0.12, repeat: Infinity, ease: "easeInOut" } : { duration: 0.3 }}
            initial={{ scaleY: 0.14 }}
          />
        );
      })}
    </div>
  );
}
